import {Component, Input, OnInit} from '@angular/core';
import {AutorunComponent} from '@myshared/autorun.component';
import {Model} from '../../app.model';
import {Subscription} from '../../subscription/subscription.model';
import {Block} from '../phonenumber.model';
import {PhonenumberService} from '../phonenumber.service';
import {ConfirmationService} from 'primeng/api';
import {I18NextService} from 'angular-i18next';
import { Router } from '@angular/router';
import { DeviceService } from 'src/app/device.service';
import { SaleOrder } from 'src/app/buy/buy.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { OrderService } from 'src/app/order/order.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-phonenumber-card',
    templateUrl: './phonenumber-card.component.html',
    standalone: false
})
export class PhonenumberCardComponent extends AutorunComponent implements OnInit {

  @Input() public clickable = true;
  @Input() public block: Block;
  @Input() public subscriptionInput?: Subscription;

  public isPartner: boolean;
  public isAdmin: boolean;

  constructor(private m: Model,
              private phoneNumberService: PhonenumberService,
              private confirmationService: ConfirmationService,
              private subscriptionService: SubscriptionService,
              private orderService: OrderService,
              private i18next: I18NextService,
              private router: Router,
              private deviceService: DeviceService) {
    super();
  }

  async ngOnInit() {
    this.autorun(() => {
      this.isPartner = this.m.account.currentUser.companyIsPartner;
      this.isAdmin = this.m.account.isMypascomAdmin;
    });
  }

  get hasScheduledOrder(): boolean {
    return !!this.scheduledOrder;
  }

  get subscription(): Subscription {
    return this.subscriptionInput ?? this.block.appliance;
  }

  public get isBlock(): boolean {
    return this.block.numbers.length > 1;
  }

  public get cssClass() {
    return {
      'pending': this.block.status === 'pending',
      'active': this.block.status === 'active',
      'dead': this.block.status === 'dead',
    };
  }

  public get statusTranslationKey() {
    return 'trunk_status_' + this.block.status;
  }

  public get statusDescriptionTranslationKey() {
    return 'trunk_status_' + this.block.status + '_description';
  }

  public cancelPhoneNumber() {
    this.router.navigate(['/do', ...this.roleSegment, 'cancel-phonenumber', this.subscription.appliance_id, this.block.id, 'confirm']);
  }

  public async getSubscription() {
      const fullSub = await firstValueFrom(this.subscriptionService.getSubscriptionDetails(+this.block.appliance.appliance_id));
      this.subscriptionInput = Subscription.fromJson(fullSub);
  }

  public get scheduledOrder() {
    return this.subscription.getScheduledCancelNumberOrder(this.block.id);
  }

  public async openSubscription() {
    if (!this.subscriptionInput) {
      await this.getSubscription();
    }
  }

  private get roleSegment() {
    if (!this.subscription?.is_my) {
      const user = this.m.account.currentUser;
      if (user.companyIsPC20Csp) return ['csp'];
      else if (user.companyIsPartner) return ['partner'];
    }
    return [];
  }

  public cancelOrder() {
    this.confirmationService.confirm({
      message: this.i18next.t('confirm_cancel_order_text') as string,
      header: this.i18next.t('confirm_cancel_order') as string,
      acceptLabel: this.i18next.t('confirm_cancel_order') as string,
      rejectLabel: this.i18next.t('app_cancel') as string,
      accept: () => {
        this.orderService.cancelOrder(this.subscription, this.scheduledOrder?.name ?? '')!.subscribe(() => {
          window.location.reload();
        });
      }
    });
  }

  public get isBlockActive() {
    return this.block.status === 'active';
  }

  public get isNotATrial() {
    return !this.subscription?.isOneTrial;
  }

  public showDetails() {
    if (this.canShowDetails) {
      this.router.navigate(['/subscriptions',this.subscription?.appliance_id]);
    }
  }

  public get canShowDetails() {
    return this.subscription?.isValid && this.clickable;
  }

  private get isMySubscriptionOrPartner() {
    return this.subscription?.is_my || this.isPartner;
  }
}
